import { Text } from "@fragments";

import "./styles.scss";

function calculateDays(start, end) {
    const diff = Math.abs(new Date(end) - new Date(start));
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

function formatDate(d) {
    return new Date(d).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "short",
    });
}

export default function Progress({ interval }) {
    if (!interval) return null;

    const { start_date, end_date } = interval;

    const duration = calculateDays(start_date, end_date);
    const today = new Date();
    const started = today > new Date(start_date);
    const finished = today > new Date(end_date);
    const elapsedDays = started
        ? Math.min(calculateDays(start_date, today), duration)
        : 0;
    const percent = Math.floor((elapsedDays / duration) * 100);

    return (
        <div className="challenge-progress">
            <div className="challenge-progress__bar-track">
                <div
                    className="challenge-progress__bar-fill"
                    style={{ width: `${finished ? 100 : percent}%` }}
                />
            </div>
            <div className="challenge-progress__labels">
                <Text.span contrast={5}>
                    {finished
                        ? "Desafio concluído"
                        : started
                            ? `${elapsedDays}/${duration} dias`
                            : "Aguardando início"}
                </Text.span>
                <div
                    style={{
                        display: "flex",
                        gap: "var(--gap-2)",
                        alignItems: "center",
                    }}
                >
                    <Text.span contrast={4}>{formatDate(start_date)}</Text.span>
                    <Text.span contrast={3}>→</Text.span>
                    <Text.span contrast={4}>{formatDate(end_date)}</Text.span>
                    <Text.span contrast={7} className="bold">
                        {finished ? "100%" : `${percent}%`}
                    </Text.span>
                </div>
            </div>
        </div>
    );
}
